const tokenUrl = "https://us1.pusherplatform.io/services/chatkit_token_provider/v1/0edbe8b2-c438-4d93-8da9-313682d6da17/token";
const instanceLocator = "v1:us1:0edbe8b2-c438-4d93-8da9-313682d6da17";
const key = "41c8b1a6-905d-4f3d-a591-edc634889f4f:f9nGYcGsf5eE4tSeUsFrEPm0F2B2wZXFda8T9+doRAw=";

export {
  tokenUrl,
  instanceLocator,
  key
}



// WEBPACK FOOTER //
// ./src/config.js